import { Slide, SlideProps } from '@mui/material';
import { theme } from '../../styles/theme';

// mobile: a Menu/Popover as a bottom sheet that slides up, instead of growing from the anchor
export const mobileSheetSx = {
    '& > .MuiPaper-root': {
        position: 'fixed',
        left: '0 !important',
        right: 0,
        top: 'auto !important',
        bottom: 0,
        width: '100%',
        maxWidth: '100%',
        borderRadius: theme.spacing(2, 2, 0, 0),
    },

    '.MuiMenuItem-root': {
        height: theme.spacing(6),
        px: theme.spacing(1.5),
    },
};

export const mobileSheetProps = {
    anchorReference: 'none' as const,
    TransitionComponent: Slide,
    TransitionProps: { direction: 'up' } as SlideProps,
};
